import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HeroSection.css';
import AnnouncementBanner from '../pages/AnnouncementBanner';

const HeroSection = () => {
  return (
    <div style={{ position: 'relative' }}>
      <div style={{ 
        position: 'relative',
        top: '80px',
        left: 0,
        right: 0,
        zIndex: 10
      }}>
        <AnnouncementBanner />
      </div>
      <section className="hero">
        <div className="hero-content">
          <h1>Making Nonprofit Work Easy for the Cause</h1>
          <p>
            At Cause and Impact, we empower changemakers to focus on their mission
            while we handle the back-office complexities.
          </p>
          <div className="hero-buttons">
            <Link to="/apply" className="hero-btn hero-btn-primary">
              Apply Now
            </Link>
            <Link to="/donate" className="hero-btn hero-btn-secondary">
              Donate Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
